import {
  Action,
  getModule,
  Module,
  Mutation,
  VuexModule
} from "vuex-module-decorators";
import store from "@/store";
import { EditableUserQualificationItems } from "@/types/qualification/EditableUserQualificationItems";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "register"
})
class RegisterModule extends VuexModule {
  qualifications: EditableUserQualificationItems[] = [];

  @Mutation
  private ADD_QUALIFICATION(qualification: EditableUserQualificationItems) {
    this.qualifications = [...this.qualifications, qualification];
  }

  @Mutation
  private UPDATE_QUALIFICATION(body: {
    index: number;
    qualification: EditableUserQualificationItems;
  }) {
    this.qualifications.splice(body.index, 1, body.qualification);
  }

  @Mutation
  private DELETE_QUALIFICATION(index: number) {
    this.qualifications.splice(index, 1);
  }

  @Mutation
  private CLEAR_QUALIFICATIONS() {
    this.qualifications = [];
  }

  @Action
  addQualification(qualification: EditableUserQualificationItems): boolean {
    // 同じ資格が既に存在するかチェック
    const isDuplicate = this.qualifications.some(
      existing => existing.qualification === qualification.qualification
    );

    if (isDuplicate) {
      return false;
    }

    this.ADD_QUALIFICATION(qualification);
    return true;
  }

  @Action
  updateQualification(body: {
    index: number;
    qualification: EditableUserQualificationItems;
  }) {
    this.UPDATE_QUALIFICATION(body);
  }

  @Action
  deleteQualification(index: number) {
    this.DELETE_QUALIFICATION(index);
  }

  @Action
  clearQualifications() {
    this.CLEAR_QUALIFICATIONS();
  }
}

export const registerStore = getModule(RegisterModule);
